module.exports = __webpack_public_path__ + "static/rwd-ccd03457b29c4e024905d37808170282.jpg";